import type { FC } from 'react';
import { useState } from 'react';
import { Alert, useBreakpoint } from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

import type { ProductServiceItemProps } from './ProductServiceItem/ProductsServiceItem';
import ProductServiceItem from './ProductServiceItem/ProductsServiceItem';
import { ProductServicesModal } from './ProductServicesModal';
import { ShowDetails } from './ShowDetails';

export interface ProductServicesListProps {
  'data-testid'?: string;
  services: ProductServiceItemProps[];
}

const LABEL_SEND_EMAIL = 'Te enviaremos un correo para agendar los servicios.';

const ProductServiceList: FC<ProductServicesListProps> = ({
  'data-testid': dataTestId = 'paris-product-extra',
  services
}) => {
  const { isMobile } = useBreakpoint();
  const [modalOpen, setModalOpen] = useState(false);
  const isUniqueService = services.length === 1;
  const productServices = services.filter(
    (service) => service.type !== 'warranty'
  );
  const servicesToShow = isMobile ? services.slice(0, 3) : services;
  const hasServices = Boolean(services?.length);
  const showEmailAlert = Boolean(productServices.length);
  const showDetailsButton = isMobile && hasServices && !isUniqueService;

  return (
    <div
      data-testid={dataTestId}
      className={classNames('co-flex co-gap-2 co-justify-between', {
        'co-flex-col': isMobile && isUniqueService
      })}
    >
      <div
        className={classNames('co-flex co-gap-2', {
          'co-flex-col': !isMobile
        })}
      >
        {servicesToShow?.map((service, index) => (
          <ProductServiceItem
            key={index}
            {...service}
            showText={!isMobile || isUniqueService}
          ></ProductServiceItem>
        ))}

        {!isMobile && showEmailAlert && (
          <Alert status="info" body={LABEL_SEND_EMAIL}></Alert>
        )}
      </div>

      {isMobile && showEmailAlert && isUniqueService && (
        <Alert status="info" body={LABEL_SEND_EMAIL}></Alert>
      )}

      {showDetailsButton && <ShowDetails setModalOpen={setModalOpen} />}

      <ProductServicesModal
        data-testid="product-services-modal"
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        services={services}
      />
    </div>
  );
};

export default ProductServiceList;
